module.exports = __webpack_public_path__ + "img/hero2.1da8ccd0.png";